<template>
    <v-row justify="center" style="margin:0;">
        <button class="btn-style" @click.stop="open()" :hidden="hiddenButton">SUPPORT</button>
        <v-dialog persistent v-model="dialog" class="mx-auto" max-width="410" style="max-height: 100%">
            <v-card class="dialog-style">
                <div v-if="submitted" class="dialog-header">THANK YOU</div>
                <div v-else class="dialog-header">I NEED HELP</div>
                <v-form class="form-margin" ref="form">
                    <div v-if="submitted"  class="help-tips">
                        We have received your message, and we’ll be in touch as soon as we have an answer for you.
                    </div>                  
                    <div v-if="error" class="help-tips">
                        An error has occurred during the submission, please close this page and try again
                    </div>
                    <div v-if="!submitted && !error" class="help-tips">
                        Let us know how we can help, and we’ll be in touch as soon as we have an answer for you.
                    </div>
                    <div v-if="!submitted && !error">
                        <v-text-field outlined style="margin-top: 10px" class="input-text" v-model="email" v-if="user_email_unknown" :rules="[v => !!v || 'E-mail is required',v => /.+@.+\..+/.test(v) || 'E-mail must be valid']" label="Your email?" required></v-text-field>
                        <v-textarea class="input-text" v-model="description" :rules="[v=>!!v || 'Description is required']" auto-grow outlined color="grey" label="How can we help you?" rows="4" required></v-textarea>
                    </div>
                </v-form>
                <v-row v-if="submitted || error" justify="space-around" style="padding-bottom: 40px; padding-top: 10px; margin: 0 13px;">
                    <button v-if="!busy" @click="close()" class="submit-button">CLOSE</button>
                </v-row>
                <v-row v-if="!submitted && !error" justify="space-around" style="padding-bottom: 40px; padding-top: 10px; margin: 0 13px;">
                    <button @click="close()" class="cancel-button">CANCEL</button>
                    <button v-if="!busy" @click="submit()" class="submit-button">SUBMIT</button>
                    <button v-else class="submit-button"><span class="spin">&bull;</span></button>
                </v-row>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import Client from '../client.js';
export default {
    name: 'Web2Case',
    data: function(){
        return {
            hiddenButton: true,
            dialog: false,
            submitted: false,
            busy: false,
            user_email_unknown: true,
            email: '',
            description: '',
            error: false
        }
    },
    watch:{
        $route (to, from){
            if(to != from){
                this.hiddenButton = true;
                setTimeout(() => {
                    this.hiddenButton = false;
                }, 5000)
            }
        }
    },
    async mounted(){
        //waiting for 5 sec before the button appear
        setTimeout(() => {
            this.hiddenButton = false;
        }, 5000)
    },
    methods: {
        open: async function(){

            this.busy= false;
            this.description = '';
            let client = Client();
            let res = await client.get(`/web2case/email`);
            this.email = res.data.email
            this.user_email_unknown = res.data.user_email_unknown
            this.dialog = true;
            this.hiddenButton = true;

        },
        close: function(){

            this.dialog = false;
            this.hiddenButton = false;
            this.busy=false;
            this.user_email_unknown=true;
            this.description = ''; 
            this.email=''
            this.submitted = false;
            this.error = false;
        },
        submit: async function(){

            this.busy = true;
            
            if(!this.$refs.form.validate()){
                this.busy = false;
                return
            }
            const client = Client();
            const data = {
                "email": this.email,
                "description": `Source_Url: ${window.location.href}\n\nDetails:\n${this.description}`,
                "subject": 'Support Request'
            }
            const res = await client.post(`web2case`, data);
            this.busy = false;
            if(res.status === 200){
                this.submitted = true;
            }else{
                this.error = true;
                console.log(res)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 970px){  
    .btn-style
    {
        font-family: Poppins;
        font-size: 9px;
        font-weight: 1000;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        text-align: center;
        background-color: white;
        color: #4d4d4d;
        width: 53px;
        height: 53px;
        border-radius: 10px;
        border: solid 2px #4d4d4d;
        position: fixed;
        bottom: 85px;
        right: 15px;
        z-index: 999;
    }
    
}

@media screen and (min-width: 970px){  

    .btn-style
    {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: center;
        background-color: white;
        color: #4d4d4d;
        width: 140px;
        height: 53px;
        border-radius: 3px;
        border: solid 2px #4d4d4d;
        position: fixed;
        bottom: 15px;
        right: 30px;
        z-index: 999;
    }
    
}

.dialog-style{
    width: 410px;
}

.btn-style:hover
{
    background-color: #4d4d4d;
    color: white;
}

.submit-button
{
    width: 170px;
    height: 53px;
    border-radius: 3px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: center;
    border-radius: 3px;
    border: solid 2px #ea7f1d;
    background-color: #ea7f1d;
    color: white;
    margin: 10px;
}

.submit-button:hover
{
  color: #ea7f1d;
  background-color: white;
}

.cancel-button
{
  width: 170px;
  height: 53px;
  border-radius: 3px;
  border: solid 2px #4d4d4d;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #4d4d4d;
  margin: 10px;
}

.cancel-button:hover
{
    background-color: #4d4d4d;
    color: white;
}

.help-tips
{
  max-width: 340px;
  height: 53px;
  font-family: Hind;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: black;
  margin-bottom: 20px;
}

.spin {
    color: white;
    display: flex;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}

@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}

.form-margin
{
    margin: 10px 24px 0 24px;
}
.dialog-header
{
    height: 75px;
    font-family: Dosis;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    color: black;
    padding-top: 40px;
    margin-bottom: 20px;

}
.input-text {
    font-family: Hind;
}
</style>